import React from 'react';
import { I18n } from 'react-redux-i18n';
import { NewTable } from '@common/components/new-table';
import { MODULE_NAME } from '@modules/invite-status/constants/shared';
import { Search } from '@common/components/Search';
import { Flex } from '@common/components/Flex';
import { HistoryLog } from "../history-log";
import { IndividualChooserProps, useIndividualChooserController } from './individual-chooser.controller';

import './individual-chooser.styles.scss';

export const IndividualChooser: React.FC<IndividualChooserProps> = (props) => { 
  const { selectedIndividual, getHistoryLogs } = props;
  const {
    loadingIndividuals,
    loadingHistoryLogs,
    individuals,
    historyLogs,
    handleSelectedItemsChange,
    getId,
    itemUniqProperty,
    handleLoadData,
    individualsTotalCount,
    individualsLoadMetadata,
    processedColumns,
    individualsColumns,
    handleSearch,
  } = useIndividualChooserController(props);

  return (
    <div className="InviteStatusIndividualChooser">
      <h6 className="InviteStatusIndividualChooser__title">{I18n.t('Select Individuals To Invite')}</h6>
      <Search withLiveSearch id="bw-quest-invites-step4-sel-ind-search-search-box" onSearch={handleSearch} />
      <Flex className="InviteStatusIndividualChooser__content-wrapper">
        <NewTable
          disableAutoInit
          classes={{
            root: 'InviteStatusIndividualChooser__table'
          }}
          data={individuals}
          getId={getId}
          itemUniqProperty={itemUniqProperty}
          moduleName={`${MODULE_NAME}_patient_invite_individuals_chooser`}
          columns={processedColumns}
          loading={{
            list: loadingIndividuals,
          }}
          noDataMessage={I18n.t("There no individuals to display")}
          errorMessage={{ list: I18n.t('Failed to load individuals history') }}
          infiniteScroll
          selection={{
            type: 'single',
            items: selectedIndividual ? [selectedIndividual] : [],
            onChange: handleSelectedItemsChange,
          }}
          totalItemsCount={individualsTotalCount}
          loadMetadata={individualsLoadMetadata}
          onLoadData={(loadMetadata) => {
            return handleLoadData({
              columns: individualsColumns,
              loadedIndividuals: individuals,
              ...loadMetadata,
            });
          }}
        />
        {getHistoryLogs && (
          <HistoryLog 
            className="InviteStatusIndividualChooser__history-log"
            data={historyLogs}
            authorFullName={selectedIndividual?.name || ''}
            loading={loadingHistoryLogs}
          />
        )}
      </Flex>
    </div>
  );
};